import React from 'react';
import { graphql, createFragmentContainer } from 'react-relay';
import { TableRow, TableRowColumn } from 'material-ui/Table';
import Grid from '../grid/Grid';
import enhancer from '../enhancer';

class Countries extends React.Component {
  renderRow = ({ node }) => (
    <TableRow key={node.id}>
      <TableRowColumn>{node.name}</TableRowColumn>
      <TableRowColumn>{node.code}</TableRowColumn>
    </TableRow>
  );

  render() {
    const { master } = this.props;

    return (
      <div>
        <Grid
          headers={['Name', 'Code']}
          rows={master.allCountries.edges}
          renderRow={this.renderRow}
        />
      </div>
    );
  }
}

const query = graphql`
  query CountriesAdminQuery {
    master {
      ...Countries_master
    }
  }
`;

export default enhancer(Countries, {
  relay: {
    query,
    create: () =>
      createFragmentContainer(Countries, {
        master: graphql`
          fragment Countries_master on Master {
            allCountries(first: 50) {
              edges {
                node {
                  id
                  name
                  code
                }
              }
            }
          }
        `,
      }),
  },
});



// WEBPACK FOOTER //
// ./src/components/master/Countries.js